/**
 * Inline SVG glyphs for the transform bar (issue #346): flip horizontal
 * / vertical and rotate 90° left / right. The flip icons reuse the
 * Mirror sub-tool glyph (two mirrored triangles about a dashed axis) —
 * as-is for the horizontal flip, and rotated 90° left for the vertical
 * one so the reflection axis runs horizontally. The rotate icons come
 * from `rotate-left.svg` / `rotate-right.svg`.
 */

import { MIRROR_TOOL_ICON_SVG } from "./mirrorTool";
import rotateLeftRaw from "./rotate-left.svg?raw";
import { stripIconSvg } from "./stripIconSvg";
import rotateRightRaw from "./rotate-right.svg?raw";

// `rotate-left.svg` / `rotate-right.svg` carry `style="fill:currentColor"`
// now, so the shared normaliser is all these need — this module used to run its
// own strip that also rewrote `#000000` to `currentColor`, which is the third
// private normaliser #216 folded back into the files.

// Flip across the vertical axis (left ⇄ right) — the Mirror glyph as-is.
export const FLIP_HORIZONTAL_ICON = MIRROR_TOOL_ICON_SVG;

// Flip across the horizontal axis (top ⇄ bottom) — the same glyph turned
// 90° left (CCW) about its centre, so its dashed axis lies horizontally.
// Derived from the shared icon so the two stay visually in lockstep.
export const FLIP_VERTICAL_ICON = MIRROR_TOOL_ICON_SVG.replace(
  /(<svg[^>]*>)/,
  '$1<g transform="rotate(-90 12 12)">',
).replace("</svg>", "</g></svg>");

// Rotate 90° clockwise (= "right") / counter-clockwise (= "left"), from
// the provided SVG assets.
export const ROTATE_RIGHT_ICON = stripIconSvg(rotateRightRaw);
export const ROTATE_LEFT_ICON = stripIconSvg(rotateLeftRaw);
